import React from 'react';
import { InvoiceDownloaderZipFileIcon } from '../../icons/InvoiceDownloaderZipFileIcon';
import { InvoiceDownloaderLogsIcon } from '../../icons/InvoiceDownloaderLogsIcon';

interface InvoiceDownloaderDownloadButtonsProps {
  downloadLink: string;
  userSessionCounter: number;
  onDownloadZipFile: (e: React.FormEvent) => void;
  onDownloadLogsFile: (e: React.FormEvent) => void;
}

export const InvoiceDownloaderDownloadButtons: React.FC<
  InvoiceDownloaderDownloadButtonsProps
> = ({
  downloadLink,
  userSessionCounter,
  onDownloadZipFile,
  onDownloadLogsFile,
}) => {
  if (downloadLink === '') {
    return null;
  }

  return (
    <div className="max-w-xs flex justify-center">
      <button
        data-testid="download-zip-button"
        className="btn btn-primary"
        onClick={onDownloadZipFile}
      >
        Download ZIP from Session {userSessionCounter}
        <InvoiceDownloaderZipFileIcon key="download-zip-file-icon" />
      </button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button
        data-testid="download-logs-button"
        className="btn btn-primary"
        onClick={onDownloadLogsFile}
      >
        Download Logs from Session {userSessionCounter}
        <InvoiceDownloaderLogsIcon key="download-logs-file-icon" />
      </button>
    </div>
  );
};
